'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermForm$() {
  this.aKF = null;
  this.aKW = null;
  this.aKI = null;
  this.aKJ = false;
  this.aKO = null;
  this.aKP = false;
  this.aKU = null;
  this.aKV = false;
  this.aKG = null;
  this.aKH = false;
  this.aKS = null;
  this.aKT = false;
  this.aKQ = null;
  this.aKR = false;
  this.aKK = null;
  this.aKL = false;
  this.aKM = null;
  this.aKN = false;
  $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermForm$ = this;
  this.aKF = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Incoterm$();
  this.aKW = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Incoterm$());
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermForm$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermForm$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermForm$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermForm$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermForm$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermForm$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermForm$.prototype = $p;
$p.eR = (function() {
  return this.aKF;
});
$p.eO = (function() {
  return this.aKW;
});
$p.bW = (function() {
  if ((!this.aKJ)) {
    this.aKI = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aKJ = true;
  }
  return this.aKI;
});
$p.b9 = (function() {
  if ((!this.aKP)) {
    this.aKO = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aKP = true;
  }
  return this.aKO;
});
$p.b3 = (function() {
  if ((!this.aKV)) {
    this.aKU = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aKV = true;
  }
  return this.aKU;
});
$p.aG = (function() {
  if ((!this.aKH)) {
    this.aKG = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aKH = true;
  }
  return this.aKG;
});
$p.az = (function() {
  if ((!this.aKT)) {
    this.aKS = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aKT = true;
  }
  return this.aKS;
});
$p.aY = (function() {
  if ((!this.aKR)) {
    this.aKQ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aKR = true;
  }
  return this.aKQ;
});
$p.a5m = (function() {
  if ((!this.aKL)) {
    this.aKK = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Incoterm";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aKL = true;
  }
  return this.aKK;
});
$p.bNx = (function() {
  if ((!this.aKN)) {
    this.aKM = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_components_TextKindFor$().jx;
    this.aKN = true;
  }
  return this.aKM;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermForm$, "app.data.data_point_types$package$IncotermForm$", ({
  FR: 1,
  N: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermForm$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermForm$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermForm$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermForm$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermForm$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermForm$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermForm$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermForm$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermForm$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermForm$ };
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Incoterm$() {
  this.aKD = null;
  this.aKE = false;
  this.aKB = null;
  this.aKC = false;
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Incoterm$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Incoterm$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Incoterm$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Incoterm$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$Incoterm$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$Incoterm$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$Incoterm$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$Incoterm$.prototype = $p;
$p.aA = (function() {
  if ((!this.aKE)) {
    this.aKD = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aKE = true;
  }
  return this.aKD;
});
$p.bs0 = (function() {
  if ((!this.aKC)) {
    this.aKB = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermForm$().a5m();
    this.aKC = true;
  }
  return this.aKB;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$Incoterm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Incoterm$, "app.data.data_point_types$package$Incoterm$", ({
  FQ: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$Incoterm$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$Incoterm$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$Incoterm$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Incoterm$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$Incoterm$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$Incoterm$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Incoterm$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$Incoterm$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Incoterm$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Incoterm$ };
//# sourceMappingURL=app.data.data_point_types$package$-Incoterm$.js.map
